import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { ProcessesTaskConfigurationSendDocumentTemplate } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import WorkflowsTag from 'modules/documents/components/DocumentTemplates/Tags/WorkflowsTag'

interface Props {
  taskConfigurations: ProcessesTaskConfigurationSendDocumentTemplate[]
}

const WorkflowsIntegration = ({ taskConfigurations }: Props) => {
  if (!taskConfigurations?.length) return null

  return (
    <Box gap="s6">
      <Text.Header2>{i18n.t('documents.document_templates.integrations.title')}</Text.Header2>

      <Box flexDirection="row" gap="s6">
        <Text.Normal>{i18n.t('documents.document_templates.integrations.connected')}</Text.Normal>

        <WorkflowsTag taskConfigurations={taskConfigurations} />
      </Box>
    </Box>
  )
}

export default WorkflowsIntegration
